import apiClient from "./client";

const API_BASE = process.env.REACT_APP_API_URL || "/api/v1";

export async function getAppeals({ all = false } = {}) {
  const params = all ? "?all=true" : "";
  return apiClient.get(`/appeals${params}`);
}

export async function getAppeal(id) {
  return apiClient.get(`/appeals/${id}`);
}

export async function createAppeal({
  banCategories,
  timeOfBan,
  accountability,
  incidentContext,
  ruleQuestions,
  minecraftUsername,
}) {
  return apiClient.post("/appeals", {
    banCategories,
    timeOfBan,
    accountability,
    incidentContext,
    ruleQuestions,
    ...(minecraftUsername ? { minecraftUsername } : {}),
  });
}

export async function replyToAppeal(id, content, attachments = [], options = {}) {
  const isInternalNote = Boolean(options.isInternalNote);
  if (attachments.length === 0) {
    return apiClient.post(`/appeals/${id}/messages`, {
      content,
      isInternalNote,
    });
  }

  const formData = new FormData();
  formData.append("content", content);
  formData.append("isInternalNote", String(isInternalNote));
  attachments.forEach((file) => formData.append("attachments", file));

  const headers = {};
  if (apiClient.accessToken) {
    headers["Authorization"] = `Bearer ${apiClient.accessToken}`;
  }

  const response = await fetch(`${API_BASE}/appeals/${id}/messages`, {
    method: "POST",
    headers,
    body: formData,
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || "Failed to reply");
  }
  return data;
}

export async function updateAppealStatus(id, status) {
  return apiClient.patch(`/appeals/${id}/status`, { status });
}

export async function updateAppealAwaitingReply(id, awaitingReplyFrom) {
  return apiClient.patch(`/appeals/${id}/awaiting-reply`, { awaitingReplyFrom });
}

export async function updateAppealCategories(id, banCategories) {
  return apiClient.patch(`/appeals/${id}/categories`, { banCategories });
}

export async function assignAppealStaff(id, assignedStaffId) {
  return apiClient.patch(`/appeals/${id}/assignee`, { assignedStaffId: assignedStaffId || null });
}

export async function getAppealAssignableStaff() {
  return apiClient.get("/appeals/assignable-staff");
}

export async function getAppealMentionSuggestions(id, query) {
  const qs = new URLSearchParams({ q: query });
  return apiClient.get(`/appeals/${id}/mention-suggestions?${qs.toString()}`);
}

export async function editAppealMessage(appealId, messageId, content) {
  return apiClient.patch(`/appeals/${appealId}/messages/${messageId}`, { content });
}

export async function deleteAppealMessage(appealId, messageId) {
  return apiClient.delete(`/appeals/${appealId}/messages/${messageId}`);
}

export async function getAppealMessageRevisions(appealId, messageId) {
  return apiClient.get(`/appeals/${appealId}/messages/${messageId}/revisions`);
}
